
import '../css/loader.css';
import '../App.css';
import '../css/privacy.css';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="loader flex-center">
      <div className="do-stuff-box">
        <div className="input-area privacy">
          <h1>Terms</h1>


          <section>
            <h2>This app</h2>
            <p>
              This app displays your Google Sheets data as flashcards. What is on
              your Google Sheets remains your responsibility.
            </p>
            <p>
              This app is provided as-is. I&apos;ll always ask you if I need to save
              your data. Otherwise, it does what it does and nothing more.
            </p>
          </section>
          <section>
            <h2>Limited Use Disclosure</h2>
            <p>
              Quick Card's use and transfer to any other app of information received from Google APIs will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes">Google API Services User Data Policy,</a> including the Limited Use requirements.
            </p>
          </section>
          <section>
            <h2>How can I help?</h2>
            <p>
              Ideas, code, feature requests, and donations are always welcome. You
              can <a href="https://www.buymeacoffee.com/sifttrainer">buy me a coffee</a>,{" "}
              <a href="https://github.com/mchonofsky/flashcard-web-app">
                contribute on GitHub
              </a>
              , or{" "}
              <a href="https://www.markchonofsky.com">get in touch</a>.
            </p>
          </section>

          <Link className="privacy-back" to="/">
            Back to app
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
